// extracted by mini-css-extract-plugin
module.exports = {"tehranto-404":"__404_tehranto-404__whi4g","image":"__404_image__9J__s"};